import React, { createContext, useEffect, useState } from "react";

export const GridStateContext = createContext({
  isLoading: false,
  currentPageIndex: 0,
  setCurrentPageIndex: (value: number) => {},
  setIsLoading: (value: boolean) => {},
});

const GridStateProvider: React.FC = ({ children }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [currentPageIndex, setCurrentPageIndex] = useState<number>(0);

  useEffect(() => {
    const currentPage = sessionStorage.getItem("currentPage");
    if (currentPage) setCurrentPageIndex(+currentPage);
  }, []);

  useEffect(() => {
    if (isLoading) {
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  }, [isLoading]);

  return (
    <GridStateContext.Provider
      value={{
        isLoading,
        setIsLoading,
        currentPageIndex,
        setCurrentPageIndex: (value) => {
          setTimeout(() => {
            setCurrentPageIndex(value);
            sessionStorage.setItem("currentPage", value.toString());
          }, 1100);
        },
      }}
    >
      {children}
    </GridStateContext.Provider>
  );
};

export default GridStateProvider;
